// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
console.log("About to import controllers...")
import { application } from "./controllers/application"  // Import the Stimulus application
import "./controllers"
console.log("Finished importing controllers")

console.log("Turbo Rails loaded")

import { Turbo } from "@hotwired/turbo-rails"
// import { PWAPrompt } from './pwa_prompt'
import { AddToHomeScreen } from './add_to_home_screen'

// Enable debug mode for Turbo
Turbo.setProgressBarDelay(0)

// Global Turbo event listeners
document.addEventListener("turbo:load", () => {
  console.log("🟢 Turbo load")
  // new AddToHomeScreen()
})

document.addEventListener("turbo:frame-load", () => {
  console.log("🟢 Turbo frame load")
})

document.addEventListener("turbo:before-stream-render", () => {
  console.log("🟢 Turbo before stream render")
})

document.addEventListener("turbo:submit-start", (event) => {
  console.log("🟢 Turbo submit start", event)
})

document.addEventListener("turbo:submit-end", (event) => {
  console.log("🟢 Turbo submit end", event)
})

document.addEventListener("turbo:stream-connect", (event) => {
  console.log("Turbo stream connected to:", event.target?.channel)
})

document.addEventListener("turbo:before-stream-render", (event) => {
  console.log("Stream update received for:", event.target?.target)
})

document.addEventListener("turbo:stream-render", (event) => {
  console.log("Stream rendered for:", event.target?.target)
})

document.addEventListener("turbo:stream-error", (event) => {
  console.error("Turbo stream error:", event)
})

// Add these after your existing event listeners
document.addEventListener("turbo:before-fetch-request", (event) => {
  console.log("🔄 Turbo fetch starting", event)
})

document.addEventListener("turbo:before-fetch-response", (event) => {
  console.log("📥 Turbo fetch response", event)
})

document.addEventListener("turbo:upload-progress", (event) => {
  const [total, loaded] = event.detail.fetchResponse.uploadProgress
  const progress = (loaded / total) * 100
  console.log(`⏫ Turbo upload progress: ${progress.toFixed(2)}%`)
})

document.addEventListener('DOMContentLoaded', () => {
  // new PWAPrompt();
  console.log('loaded......................')
  new AddToHomeScreen()
})
